// 该state 主要依据知识点 进行单个展示，并处理相应下的练习 的整个流程

// 如果有存在 knowledgePoints 对 state赋值， 不存在 置空 state
export const POINTS_SET_ITEMS = 'POINTS_SET_ITEMS';

// 功能操作 mutations 更新讲义 包含知识点更新 及 难度更新
export const POINTS_CHANGE_COURSEWARE = 'POINTS_CHANGE_COURSEWARE';

// 编辑课节，移除部分知识点 mutations
export const POINTS_REMVOE_ITEMS = 'POINTS_REMVOE_ITEMS';

// 同步课节名称修改， mutations
export const POINTS_SYNC_SESSION_NAME = 'POINTS_SYNC_SESSION_NAME';

// 编辑课节， 新增知识点需要获取推荐习题 actions
export const POINTS_EDIT_SESSION = 'POINTS_EDIT_SESSION';
export const POINTS_SET_SESSION = 'POINTS_SET_SESSION';

// 讲义难度更新，获取新的推荐习题 actions
export const POINTS_GET_DIFFICULTY_POINT = 'POINTS_GET_DIFFICULTY_POINT';
export const POINTS_SET_DIFFICULTY_POINT = 'POINTS_SET_DIFFICULTY_POINT';

// 操作问题，移动问题 向上，向下 mutations
export const POINTS_MOVE_QUESTION = 'POINTS_MOVE_QUESTION';
// 操作问题，删除问题 mutations
export const POINTS_DELETE_QUESTION = 'POINTS_DELETE_QUESTION';
// 换组问题
export const POINTS_TURN_QUESTION = 'POINTS_TURN_QUESTION';

// **************  添加习题(知识库相关)  ****************

// 将所选问题添加到试题篮中 mutations
export const POINTS_KB_IN_BASKET = 'POINTS_KB_IN_BASKET';
export const POINTS_KB_OUT_BASKET = 'POINTS_KB_OUT_BASKET';

// ************** 使用已有讲义  ****************

// 使用已有的讲义，替换当前知识点 mutations
export const POINTS_REPLACE_POINT = 'POINTS_REPLACE_POINT';



// WEBPACK FOOTER //
// ./src/views/index/store/types/types_points.js